import type { PasswordChangeSchema } from '@repo/schemas/auth/passwordChange';

import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useMutation } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { AuthService } from './authService';

export function usePostPasswordChange() {
  const passwordChangeMutation = useMutation({
    mutationFn: (data: PasswordChangeSchema) => AuthService.postPasswordChange(data).then((response) => response.data),
  });

  const errorMessage = useErrorMessage(passwordChangeMutation.error, baseErrorMessages);

  return {
    ...passwordChangeMutation,
    errorMessage,
  };
}
